export const defaultEmail = 'support@riddickspartners.com';
